/* Component for Notes section in the PDP */

import styles from "../sections.module.scss";

export default function Notes({ showTitle }) {
  return (
    <>
      <div className={styles["main-drawer"]}>
        <div className={styles.sub_block}>
          {showTitle && (
            <h5 className={`light ${styles.heading}`} id="productCareHeading">
              Notes
            </h5>
          )}
          <p className={styles.description} id="productCareDesc-notes">
            Lorem ipsum dolor sit amet, consecutetus adiipsing elit. Lorem ipsum
            dolor sit amet, consecutetus adiipsing elit. Lorem ipsum dolor sit
            amet, consecutetus adiipsing elit. Lorem ipsum dolor sit amet,
            consecutetus adiipsing elit.
          </p>
        </div>
      </div>
    </>
  );
}
